<div class="bg-galliano relative h-8 md:h-10">
    <!-- Desktop: Show all items in a row -->
    <div class="text-white px-4 py-2 hidden md:flex flex-row flex-nowrap justify-around items-center w-full h-full">
        <div *ngFor="let item of items" class="text-base font-semibold uppercase">
            {{ item }}
        </div>
    </div>

    <!-- Mobile: Show one item at a time with sliding animation -->
    <div class="text-white px-4 py-2 md:hidden w-full h-full overflow-hidden relative">
        <div
            class="absolute top-0 left-0 flex transition-transform duration-500 ease-in-out"
            [ngStyle]="{ width: (items.length * 100) + '%', transform: 'translateX(-' + (currentIndex() * (100 / items.length)) + '%)' }"
        >
            <div
                *ngFor="let item of items"
                class="flex-1 text-sm text-center px-4 py-2 uppercase"
                [ngStyle]="{ width: (100 / items.length) + '%' }"
            >
                {{ item }}
            </div>
        </div>
    </div>
</div>
